import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      detail = {},
      qrModalVisable,
      changeQrModalVisable
    } = this.props.store
    return (
      <Modal
        title="APP直播预览"
        visible={qrModalVisable}
        destroyOnClose={true}
        wrapClassName={Style.qr_modal}
        onCancel={changeQrModalVisable}
        footer={
          <div className={Style.qr_modal_footer}>
            <Button type="primary" onClick={changeQrModalVisable}>
              关闭
            </Button>
          </div>
        }
      >
        <div className={Style.qr_modal_content}>
          <img src={detail.appQrCode} />
          <p>打开婚礼纪商家端扫一扫，查看移动端直播详情</p>
        </div>
      </Modal>
    )
  }
}
